/**
 * selling-plan-preselect.js - opens a product page with the subscription plan
 * named in the link already chosen.
 *
 * Site:      koinoniafarmstore.com (Shopify)
 * SSOT:      projects/koinonia/koinonia-shopify/subscription-migration-2026-09/preselect-t3s/selling-plan-preselect.js
 * Lifecycle: standing
 * Loaded by: sections/main-product.liquid, deferred, only on products with selling plans
 * Requires:  Shopify Subscriptions app embed (its app-embed-block.js must load first)
 *
 * The Subscriptions widget ignores ?selling_plan= in the URL. For a link like
 * /products/x?variant=123&selling_plan=456 this clicks the matching plan radio
 * in the widget, so the app's own change handler fills the hidden
 * name="selling_plan" input and the theme re-prices. The hidden input is never
 * written directly. No parameter, a non-numeric value, or a plan the widget
 * does not offer leaves the page untouched. It re-applies after a variant
 * change until the customer picks a purchase option themselves.
 *
 * Revisions:
 *   1.0.0 - 2026-09-14 - Initial. Re-subscribe emails link straight to a plan.
 */
(function () {
  'use strict';

  var params = new URLSearchParams(window.location.search);
  var planId = params.get('selling_plan');
  if (!planId || !/^\d+$/.test(planId)) return;
  var urlVariant = params.get('variant');

  var BLOCK = '.shopify_subscriptions_app_block';
  var customerChose = false;
  // A radio's change event is trusted even when our own click() caused it,
  // so isTrusted alone cannot tell the customer's choice from ours.
  var applying = false;

  function planRadio(section) {
    return section ? section.querySelector('input[type="radio"][data-selling-plan-id="' + planId + '"]') : null;
  }

  function currentVariantId() {
    var select = document.querySelector('#product-form [name="id"]');
    return (select && select.value) || urlVariant;
  }

  function targetSections() {
    var out = [];
    var vid = currentVariantId();
    var own = vid ? document.querySelector(BLOCK + '[data-variant-id="' + vid + '"]') : null;
    if (own) out.push(own);
    // The app does not re-toggle its per-variant sections when this theme
    // changes variant, so the one the customer sees can be a different
    // variant's. Tick it too, or the page would show one-time purchase.
    var visible = document.querySelector(BLOCK + ':not(.shopify_subscriptions_app_block--hidden)');
    if (visible && visible !== own) out.push(visible);
    return out.filter(planRadio);
  }

  function apply(attempt) {
    if (customerChose) return;
    var sections = targetSections();
    if (!sections.length) return; // plan not offered here: leave the page alone
    sections.forEach(function (section) {
      var radio = planRadio(section);
      // click() fires the change event the app listens for; an already
      // checked radio fires nothing, so this is safe to repeat.
      if (!radio.checked) {
        applying = true;
        try { radio.click(); } finally { applying = false; }
      }
    });
    var hidden = document.querySelector('[name="selling_plan"]');
    if ((!hidden || hidden.value !== planId) && (attempt || 0) < 10) {
      // The app binds its radio listeners when its own script runs; if a click
      // landed first it changed nothing, so untick and try again shortly.
      sections.forEach(function (section) { planRadio(section).checked = false; });
      window.setTimeout(function () { apply((attempt || 0) + 1); }, 300);
    }
  }

  function start() {
    document.addEventListener('change', function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      if (target.closest(BLOCK)) {
        if (!applying) customerChose = true;
      } else if (target.matches('.product-option__input, .product-option__select')) {
        window.setTimeout(apply, 50);
      }
    }, true);
    apply(0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
